import { useLayoutEffect } from 'react';
import { pushDocumentTitle } from '@/utils/documentTitle';

/** Puts this title above the route default until the caller unmounts or the title changes. */
export function useDocumentTitle(title: string | null | undefined): void {
    useLayoutEffect(() => {
        if (!title) return undefined;
        return pushDocumentTitle(title);
    }, [title]);
}
